// ToastContainer.js
import React from "react";

function ToastContainer({ toasts, removeToast }) {
  return (
    <div className="fixed top-4 right-4 z-50 space-y-3">
      {toasts.map((toast) => (
        <Toast key={toast.id} toast={toast} onRemove={removeToast} />
      ))}
    </div>
  );
}

function Toast({ toast, onRemove }) {
  const getStyles = () => {
    switch (toast.type) {
      case "success":
        return "bg-green-100 border-green-400 text-green-800";
      case "error":
        return "bg-red-100 border-red-400 text-red-800";
      case "warning":
        return "bg-yellow-100 border-yellow-400 text-yellow-800";
      default:
        return "bg-blue-100 border-blue-400 text-blue-800";
    }
  };

  return (
    <div
      className={`px-4 py-3 rounded shadow border flex justify-between items-center ${getStyles()}`}
    >
      <span>{toast.message}</span>
      <button
        onClick={() => onRemove(toast.id)}
        className="ml-3 text-sm font-bold"
      >
        ✕
      </button>
    </div>
  );
}

export default ToastContainer;
